import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FetchEmployeeListItem, InternalUserItem } from '../../../../../../../../goldstar-share/src/app/api-data/ng-openapi-gen-next/models';

type EmployeeWithImage = {
	imageSrc?: string;
} & FetchEmployeeListItem;

const DEFAULT_PROFILE_IMAGE = '../../../../../../assets/images/Trb-latest-svg/trb-silhouette-transparent.png';

@Component({
	selector: 'app-employee-list',
	standalone: true,
	imports: [MatIconModule, CommonModule],
	templateUrl: './employee-list.component.html',
	styleUrl: './employee-list.component.scss',
})
export class EmployeeListComponent {
	@ViewChild('employeeListScroller') employeeListScroller!: ElementRef;

	@Input() employeeListInput!: any;
	public employeeList!: EmployeeWithImage[];

	@Input() selectedEmployeeGUIDInput!: any;
	public selectedEmployeeGUID!: string | undefined;

	@Input() isUserOnCallInput?: boolean;

	@Input() isLoading!: boolean;

	@Input() loggedInUser?: InternalUserItem;

	@Input() callUser?: any;
	handleCallUser(event: MouseEvent, employeePhoneNumber: string) {
		event.stopPropagation(); // prevent bubbling up
		if (this.callUser) {
			this.callUser({ employeePhoneNumber });
		}
	}

	@Output() getNextEmployees = new EventEmitter();
	public onScroll() {
		const element = this.employeeListScroller.nativeElement;
		const atBottom = element.scrollHeight - element.scrollTop === element.clientHeight;

		if (atBottom) {
			this.getNextEmployees.emit();
		}
	}

	@Output() getEmployeeDetails = new EventEmitter();
	selectEmployee(guid: string | null | undefined) {
		if (!guid) return;

		this.getEmployeeDetails.emit({ internalUserGUID: guid, reset: true });
	}

	public defaultProfileImage: string = DEFAULT_PROFILE_IMAGE;

	constructor() {}

	async ngOnChanges(changes: SimpleChanges) {
		if (changes['employeeListInput'] && this.employeeListInput) {
			this.employeeList = this.employeeListInput;
		}

		if (changes['selectedEmployeeGUIDInput']) {
			this.selectedEmployeeGUID = this.selectedEmployeeGUIDInput;
		}
	}
}
